import { useMemo } from 'react';

import type {
  ExtendedOptions,
  ExtendedSeriesOptionsType
} from '@/features/charts/types/highcharts';

const useChartOptions = (
  chartSeries: ExtendedSeriesOptionsType[] | undefined,
  optionsFactory: (chartSeries: ExtendedSeriesOptionsType[]) => ExtendedOptions
) => {
  const options = useMemo(() => {
    if (chartSeries) return optionsFactory(chartSeries);
  }, [chartSeries, optionsFactory]);
  return { options };
};

export default useChartOptions;
